import { UserPreferencesData } from 'src/interfaces/user-preferences.interface';
import useAuthedRequest from './useAuthedRequest';

export const useUsersPreferences = () => {
  const { get, patch } = useAuthedRequest();

  const getUserPreferences = async () => {
    return get('/users/me/preferences');
  };

  const upsertUserPreferences = async (preferences: UserPreferencesData) => {
    return patch('/users/me/preferences', preferences);
  };

  return { getUserPreferences, upsertUserPreferences };
};
